import { ComponentProps, ReactNode } from 'react';
import { Card, Grid, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';

interface Props extends Omit<ComponentProps<typeof Card>, 'children' | 'padding'> {
    title: Mews.TextKeyUnion;
    children: ReactNode;
}

export const CreatePaymentPlanDetailCard = ({ children, title, ...other }: Props) => (
    <Card padding="200" {...other}>
        <Stack spacing="200" vertical>
            <Typography textStyle="bodyMediumStrong" variant="primary" as="div">
                {lt(title)}
            </Typography>
            <Grid templateColumns="auto 1fr" columnGap="500" rowGap="100">
                {children}
            </Grid>
        </Stack>
    </Card>
);
